/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
// eslint-disable-next-line import/extensions
import axios from 'axios';
import * as actionTypes from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const setViewCheckAllocationDetails = (data) => {
  return {
    type: actionTypes.VIEW_CHECK_ALLOCATION_DETAILS,
    viewCheckAllocationDetails: data,
  };
};
export const setViewCheckAllocationTab = (data) => {
  return {
    type: actionTypes.VIEW_CHECK_ALLOCATION_TAB_DATA,
    viewCheckAllocationObj: data,
  };
};
export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

export const dispatchInvoiceGrid = (data) => ({
  type: actionTypes.GET_INVOICE_GRID,
  invoiceGrid: data,
});

export const getInvoiceGridList = (values) => {
  return (dispatch) => {
    return axios
      .post(serviceEndPoint.GET_INVOICE_GRID, values)
      .then((response) => {
        dispatch(
          dispatchInvoiceGrid(response.data && response.data.invoiceData)
        );
      })
      .catch((e) => {
        dispatch(dispatchInvoiceGrid('failed'));
      });
  };
};

export const dispatchInvoiceGetQuarter = (data) => ({
  type: actionTypes.GET_QUARTER_GRID_DATA,
  invoiceGridQuarter: data,
});
export const getInvoiceQuarterData = (values) => async (dispatch) => {
  try {
    const response = await axios.post(
      serviceEndPoint.GET_INVOICE_QuarterData,
      values
    );
    const tempObj = response.data?.quarterData?.map((item) => {
      item.checkLogNum = values.checkLogNumber;
      item.invoiceNum = values.invoiceNum;
      return item;
    });
    return dispatch(dispatchInvoiceGetQuarter(tempObj));
  } catch {
    dispatch(dispatchInvoiceGetQuarter([]));
  }
};
export const disRowSelected = (values) => {
  return {
    type: actionTypes.ROW_SELECTED,
    rowSelected: values,
  };
};

export const clearRedux = () => {
  return {
    type: actionTypes.CLEAR_REDUX,
  };
};
export const clearReduxViewCheckAllocateScreen = () => (dispatch) => {
  dispatch(dispatchInvoiceGetQuarter({}));
  dispatch(dispatchInvoiceGrid(null));
  dispatch(setViewCheckAllocationDetails({}));
  dispatch(setViewCheckAllocationTab({}));
};
  export const setActiveDetailScreenTabs = (activeDetailScreenTabs) => {
    return {
      type: actionTypes. ACTIVE_ROSI_PQAS_TAB_DETAILS,
      activeDetailScreenTabs,
    }
  }